import variables from '@styles/variables';
import { rem } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import Config from '@config';
import Spinner from '@molecules/Spinner/Spinner';

const show = keyframes`
  from {
    max-height: 0;
  }
  to {
    max-height: ${rem(999)};
  }
`;

const hide = keyframes`
  from {
    max-height: ${rem(999)};
  }
  to {
    max-height: 0;
  }
`;

export const StyledMixMatchBeam = styled.div<{ $isVisible: boolean }>`
  margin: ${rem(20)} 0 0 0;
  position: relative;
  width: calc(100% - ${rem(1)});
  background-color: ${variables.colors.lighterGray};

  ${Config.MEDIA.IS_MOBILE} {
    margin: ${rem(20)} ${rem(-20)} 0;
    width: calc(100% + ${rem(40)});
  }

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    border-radius: ${rem(30)};
    margin: ${rem(20)} ${rem(-16)} ${rem(40)};
    width: auto;
  }

  ${(props) =>
    props.$isVisible &&
    css`
      animation: ${show} ease-out ${Config.TIMEOUT.mixMatchBeamAnimationMs}ms forwards;
    `}

  ${(props) =>
    !props.$isVisible &&
    css`
      animation: ${hide} ease-in ${Config.TIMEOUT.mixMatchBeamAnimationMs}ms forwards;
    `}
`;

export const StyledMixMatchBeamArrowContainer = styled.div`
  position: relative;
`;

export const StyledMixMatchBeamArrow = styled.span`
  width: ${rem(20)};
  height: ${rem(20)};
  background-color: ${variables.colors.lighterGray};
  position: absolute;
  top: ${rem(-10)};
  transform: translateX(-50%) rotate(45deg);
`;

export const StyledSpinner = styled(Spinner)<{ $height?: number }>`
  margin: ${rem(20)} auto;
  display: flex;
  ${({ $height: height }) =>
    height &&
    css`
      min-height: ${rem(height)};
    `}
`;
